// // import axios from 'axios';
// import axios from '../../utils/axiosConfig';
// import {
//   RELATIONSHIP_DETAILS_REQUEST,
//   RELATIONSHIP_DETAILS_SUCCESS,
//   RELATIONSHIP_DETAILS_FAIL,
//   FETCH_RELATIONSHIPS_REQUEST,
//   FETCH_RELATIONSHIPS_SUCCESS,
//   FETCH_RELATIONSHIPS_FAIL,
//   CREATE_RELATIONSHIP_SUCCESS,
//   CREATE_RELATIONSHIP_FAIL,
//   UPDATE_RELATIONSHIP_SUCCESS,
//   UPDATE_RELATIONSHIP_FAIL,
//   DELETE_RELATIONSHIP_SUCCESS,
//   DELETE_RELATIONSHIP_FAIL,
//   CREATE_RELATIONSHIP_REQUEST,
// } from '../constants/relationshipConstants';

// // Fetch all relationships
// export const fetchRelationships = () => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_RELATIONSHIPS_REQUEST });
//     console.log('Fetching relationships...');
//     const { data } = await axios.get('/api/relationships');
//     console.log('Relationships:', data);
//     dispatch({ type: FETCH_RELATIONSHIPS_SUCCESS, payload: data });
//   } catch (error) {
//     dispatch({
//       type: FETCH_RELATIONSHIPS_FAIL,
//       payload: error.response?.data.message || error.message,
//     });
//   }
// };

// // Get details of a specific relationship
// export const getRelationship = (id) => async (dispatch) => {
//   try {
//     dispatch({ type: RELATIONSHIP_DETAILS_REQUEST });
//     const { data } = await axios.get(`/api/relationships/${id}`);
//     console.log('Relationship details:', data);
//     dispatch({ type: RELATIONSHIP_DETAILS_SUCCESS, payload: data });
//   } catch (error) {
//     dispatch({
//       type: RELATIONSHIP_DETAILS_FAIL,
//       payload: error.response?.data.message || error.message,
//     });
//   }
// };

// // Create a new relationship
// export const createRelationship = (relationship) => async (dispatch) => {
//   try {
//     dispatch({ type: CREATE_RELATIONSHIP_REQUEST});
//     console.log('creating rel');
//     const { data } = await axios.post('/api/relationships', relationship);
//     console.log('data', data);
//     dispatch({ type: CREATE_RELATIONSHIP_SUCCESS, payload: data });
//   } catch (error) {
//     console.log(error);
//     dispatch({
//       type: CREATE_RELATIONSHIP_FAIL,
//       payload: error.response?.data.message || error.message,
//     });
//   }
// };

// // Update an existing relationship
// export const updateRelationship = (id, updatedRelationship) => async (dispatch) => {
//   try {
//     const { data } = await axios.put(`/api/relationships/${id}`, updatedRelationship);
//     dispatch({ type: UPDATE_RELATIONSHIP_SUCCESS, payload: data });
//   } catch (error) {
//     dispatch({
//       type: UPDATE_RELATIONSHIP_FAIL,
//       payload: error.response?.data.message || error.message,
//     });
//   }
// };

// // Delete a relationship
// export const deleteRelationship = (id) => async (dispatch) => {
//   try {
//     await axios.delete(`/api/relationships/${id}`);
//     dispatch({ type: DELETE_RELATIONSHIP_SUCCESS, payload: id });
//   } catch (error) {
//     dispatch({
//       type: DELETE_RELATIONSHIP_FAIL,
//       payload: error.response?.data.message || error.message,
//     });
//   }
// };



// import axios from 'axios';
import axios from '../../utils/axiosConfig';
import {
  RELATIONSHIP_DETAILS_REQUEST,
  RELATIONSHIP_DETAILS_SUCCESS,
  RELATIONSHIP_DETAILS_FAIL,
  FETCH_RELATIONSHIPS_REQUEST,
  FETCH_RELATIONSHIPS_SUCCESS,
  FETCH_RELATIONSHIPS_FAIL,
  CREATE_RELATIONSHIP_SUCCESS,
  CREATE_RELATIONSHIP_FAIL,
  UPDATE_RELATIONSHIP_SUCCESS,
  UPDATE_RELATIONSHIP_FAIL,
  DELETE_RELATIONSHIP_SUCCESS,
  DELETE_RELATIONSHIP_FAIL,
  CREATE_RELATIONSHIP_REQUEST,
} from '../constants/relationshipConstants';

// Fetch all relationships
export const fetchRelationships = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_RELATIONSHIPS_REQUEST });
    
    // Build query string from filters
    const queryParams = new URLSearchParams();
    if (filters.type) queryParams.append('type', filters.type);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.contractType) queryParams.append('contractType', filters.contractType);
    if (filters.search) queryParams.append('search', filters.search);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/api/relationships?${queryString}` : '/api/relationships';
    
    const { data } = await axios.get(url);
    dispatch({ type: FETCH_RELATIONSHIPS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_RELATIONSHIPS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Get details of a specific relationship
export const getRelationship = (id) => async (dispatch) => {
  try {
    dispatch({ type: RELATIONSHIP_DETAILS_REQUEST });
    const { data } = await axios.get(`/api/relationships/${id}`);
    // console.log('Relationship details:', data);
    dispatch({ type: RELATIONSHIP_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: RELATIONSHIP_DETAILS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Create a new relationship
export const createRelationship = (relationship) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_RELATIONSHIP_REQUEST});
    // console.log('creating rel', relationship);
    const { data } = await axios.post('/api/relationships', relationship);
    // console.log('data', data);
    dispatch({ type: CREATE_RELATIONSHIP_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);
    // Handle duplicate error (409 status)
    if (error.response?.status === 409 && error.response?.data?.duplicate) {
      const errorMessage = error.response.data.message || 'A duplicate relationship already exists';
      dispatch({
        type: CREATE_RELATIONSHIP_FAIL,
        payload: errorMessage,
      });
    } else {
      dispatch({
        type: CREATE_RELATIONSHIP_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  }
};

// Update an existing relationship
export const updateRelationship = (id, updatedRelationship) => async (dispatch) => {
  try {
    const { data } = await axios.put(`/api/relationships/${id}`, updatedRelationship);
    dispatch({ type: UPDATE_RELATIONSHIP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_RELATIONSHIP_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Delete a relationship
export const deleteRelationship = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/relationships/${id}`);
    dispatch({ type: DELETE_RELATIONSHIP_SUCCESS, payload: id });
  } catch (error) {
    dispatch({
      type: DELETE_RELATIONSHIP_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};